export const EVENT_DIALOG_TOGGLE = 'EVENT_DIALOG_TOGGLE'
export const EVENT_DIALOG_OPEN = 'EVENT_DIALOG_OPEN'
export const EVENT_DIALOG_CLOSE = 'EVENT_DIALOG_CLOSE'
export const EVENT_DIALOG_RESET_STATE = 'EVENT_DIALOG_RESET_STATE'
